module.exports = __webpack_public_path__ + "static/media/leonardo.df13c785.png";